<template>
  <div class="checkbox">
    <div
      class="checkbox-btn"
      @click="handleToggleChoose"
    >
      <span
        v-if="activeName"
        class="name fs-black"
      >{{ activeName }}</span>
      <span
        v-else
        class="name"
      >{{ $t('message["855"]') }}</span>
      <i class="iconfont iconicon-test18" />
    </div>
    <cube-validator
      ref="formItem"
      v-model="data.valid"
      :model="data.fieldvalue"
      :data="data"
      :rules="data.rules"
      :messages="data.messages"
      :immediate="false"
    />
    <checkbox-pop
      ref="selectTreePicker"
      :options="data.options"
      :default-value="data.fieldvalue"
      :title="data.fieldname"
      @cancel="handleCancel"
      @confirm="submitHandler"
    />
  </div>
</template>

<script>
// import { clickoutside } from '@/lib/directives'
import CheckboxPop from './../CheckBoxPop'
export default {
  // directives: { clickoutside },
  components: {
    CheckboxPop
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      showChooseList: false, // 选择框是否展示
      activeKey: this.value || this.data.fieldvalue,
      activeName: '',
      checkList: [],
      timer: null
    }
  },
  computed: {
    options () {
      const { options = [] } = this.data
      return options
    }
  },
  created () {
    this.setDefault()
  },
  destroyed () {
    clearTimeout(this.timer)
  },
  methods: {
    validate (cb) {
      this.$refs.formItem.validate(cb)
    },
    /* handleToggleChoose () {
      // if (this.$refs.chooseList.contains(e.target)) return
      this.showChooseList = true

      this.setDefault()
    }, */
    handleToggleChoose () {
      /* let instance = SelectTreePop.$create()
      instance.show() */
      this.$refs.selectTreePicker.show()
      this.setDefault()
    },
    setDefault () {
      this.checkList = []
      this.options.forEach(item => {
        this.activeKey.forEach(key => {
          if (item.id === key) {
            this.checkList.push(item.name)
            this.activeName = this.checkList.join(',')
            this.$set(item, 'checked', true)
          }
        })
      })
    },

    submitHandler () {
      this.checkList = []
      this.activeKey = []
      this.options.forEach(item => {
        if (item.checked) {
          this.checkList.push(item.name)
          this.activeKey.push(item.id)
          this.activeName = this.checkList.join(',')
        }
      })

      this.data.fieldvalue = this.activeKey

      this.$emit('change', this.activeKey)

      this.showChooseList = false
    },
    handleCancel () {
      /* this.checkList = []
      this.activeKey = [] */
      this.showChooseList = false

      this.options.forEach(item => {
        this.$set(item, 'checked', false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox {
  width: 100%;
}
.checkbox-btn {
  display: flex;
  justify-content: space-between;
  color: #d6d6d6;
  align-items: center;
  // width: 200px;
  .name {
    flex: 1;
    width: 100%;
    word-break: break-all;
    line-height: 1;
    padding: 10px 0;
  }
  .iconfont {
    color: #d6d6d6;
  }
}

.cube-btn {
  width: 48%;
}
.slide-up-enter,
.slide-up-leave-active {
  -webkit-transform: translate3d(0, -200%, 0);
  transform: translate3d(0, -200%, 0);
}

.slide-up-enter-active,
.slide-up-leave-active {
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
</style>
